module.exports = __webpack_public_path__ + "static/img/1_0011.53d741f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0011.jpg
// module id = qB0+
// module chunks = 0